<template>
  <div class="myorder">
    <top-nav ref="TopNav"></top-nav>
    <!--<van-nav-bar title="我的订单" fixed left-arrow @click-left="goBack" @click-right="onClickRight">-->
      <!--<van-icon slot="right" class="iconfont icon-zhankai"></van-icon>-->
    <!--</van-nav-bar>-->
    <div class="van-content">
      <div class="van-hairline--top-bottom van-tabbar">
        <div class="van-tabbar-item" :class="this.$route.name == 'AllOrder'?'active':''">
          <router-link to="/user/myorder/allorder/?type=0" tag="div" class="van-tabbar-item__text">全部</router-link>
        </div>
        <!--<div class="van-tabbar-item" :class="this.$route.name == 'PayOrder'?'active':''">-->
          <!--<router-link to="/user/myorder/payorder?type=1" tag="div" class="van-tabbar-item__text">待付款</router-link>-->
        <!--</div>-->
        <div class="van-tabbar-item" :class="this.$route.name == 'SendOrder'?'active':''">
          <router-link to="/user/myorder/sendorder?type=2" tag="div" class="van-tabbar-item__text">待发货</router-link>
        </div>
        <div class="van-tabbar-item" :class="this.$route.name == 'TakeOrder'?'active':''">
          <router-link to="/user/myorder/takeorder?type=3" tag="div" class="van-tabbar-item__text">待收货</router-link>
        </div>
        <div class="van-tabbar-item" :class="this.$route.name == 'FinishOrder'?'active':''">
          <router-link to="/user/myorder/finishorder?type=4" tag="div" class="van-tabbar-item__text">已完成</router-link>
        </div>
      </div>
      <!--<keep-alive>-->
        <router-view></router-view>
      <!--</keep-alive>-->
    </div>
  </div>
</template>

<script>
  import TopNav from '@/components/topnav'
  export default {
    name: "index",
    components: {
      TopNav
    },
    data () {
      return {
        datas:[],
        page:0,
      }
    },
    methods: {
      goBack: function () {
        this.$router.push({ name: 'User' })
      },
      onClickRight() {
        this.$refs.TopNav.topnavPlay()
      },
    },
    mounted () {
    },
  }
</script>

<style lang="less">
  .myorder{
    .van-content{
      padding-bottom: 0;
      /*padding-top: 96px;*/
      .goodsonelist{
        margin: 0;
        background-color: #fafafa;
      }
      .van-cell-group{
        margin-top: 10px;
        background-color: #fff;
      }
      .van-tabbar{
        position: fixed;
        top: 0px;
        z-index: 1;
        .active{
          border-bottom: 2px solid #fb4141;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/user/myorder/myorder.vue